import { gql } from '@/lib/graphql/gql'

export const LOAD_BALANCER_DISPLAY_NAME_QUERY = gql`
  query LoadBalancerDisplayName(
    $idCompany: String!
    $loadBalancerName: String!
  ) {
    company(id: $idCompany) {
      id
      edgeLoadBalancer(name: $loadBalancerName) {
        id
        idCompany
        idProject
        name
        displayName
      }
    }
  }
`
